<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="headingPlant">Ticket Info</md-dialog-title>
      <bol-photo-Zoom-form ref="BolPhotoZoomForm" 
         :on-data-refresh="updatePhoto" 
         :onScan="loadWT"
         title="WT Photos (Zoom)"
      />

      <md-dialog-content>
        <form id="top" novalidate @submit.prevent="doSaveUser">
          <div class="layoutScale layoutScale">
            <div >
              <callingApiCenter class= "adjust"
                type="bar"
                :paths="['/api/w/fsi/WebSaveOutbound']"
              ></callingApiCenter>
            </div>
          </div>
         <div v-if="getTicketInfo" class="main">
            <div>
               <div class="layoutPlant">Weight Ticket <md-field><md-input v-model="item.scanWt"/></md-field></div>
               <div class="layoutPlant">Bales <md-field><md-input v-model="item.bales"/></md-field></div>
               <div class="layoutPlant">Seal Number <md-field><md-input v-model="item.newSeal"/></md-field></div> 

               <div class = "layoutPlant">Grade
                  <master-data-select group="OUTBOUND_GRADE" v-model="item.grade"/>
               </div>
               <div class = "layoutPlant">Special Grade
                  <master-data-select group="STC_SPECIAL_GRADE" v-model="item.specGrade"/>
               </div>
            </div>
          <div class="btngroup">
                <md-button class="md-raised custButtonWide" @click="scanAction"
                  ><span class="icons-center material-icons">create</span
                  >Scan</md-button
                >
                <md-button class="md-raised custButtonWide"
                   :disabled="!hasPhoto"
                   @click="toggleItemPhoto"
                  ><span class="icons-center material-icons">create</span
                  >View Scan</md-button
                >
                <md-button class="md-raised custButtonWide" @click="closeAction"
                  ><span class="icons-center material-icons">cancel</span
                  >Cancel</md-button
                >
                <md-button type="submit" class="md-raised custButtonWide"
                  ><span class="icons-center material-icons">create</span
                  >Save</md-button
                >
          </div>      
         </div>  
        <div v-if="scanWgtTicket" class="fixBlur"  style="height:1200px; width: 750px; overflow: hidden;">
          <div class="alwaysShow">
            <div>
              <md-dialog-actions>
                <div style="margin-top:50px;">
                 <!-- 
                  <md-button class="md-raised custButton" 
                    @click="cancelAction"
                    :disabled="hasError"
                    ><span class="icons-center material-icons">cancel</span
                  >Back</md-button
                 >
                 -->
                  <md-button class="md-raised custButton" 
                    @click="doCancelAction"
                    ><span class="icons-center material-icons">cancel</span
                  >Cancel</md-button
                 >
                 <!--
                 <md-button
                   type="submit"
                   class="md-raised custButton"
                 >
                 <span class="icons-center material-icons">create</span
                  >Assign</md-button
                >
                -->
                <!-- add webcam here -->
                <div class="errMsg" v-if="showErr"><label id="err"></label></div>

                <div style="margin-top:20px;">
                   <md-field style="width:300px">
                     <label>Weight Ticket Number</label>
                     <md-input v-model="dataForm.scanWt"></md-input>
                     </md-field>
                </div> 
                <hr id="pb1"/>

                
                <md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>  
            <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
            <md-button class="md-fab md-primary" @click.prevent="takePhoto" v-if="!isPhotoMode">
               <md-tooltip>Take photo and Get BOL</md-tooltip>
               <md-icon>photo_camera</md-icon>
            </md-button>   
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button v-if="isPhotoMode" class="md-fab md-primary" @click.prevent="refreshCamera">
               <md-tooltip>Back to video mode</md-tooltip>
               <md-icon>slideshow</md-icon>
            </md-button>   
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button :disabled="!this.isMultiCam" class="md-fab md-primary" @click.prevent="switchCam">
               <md-tooltip>Switch Camera</md-tooltip>
               <md-icon>flip</md-icon>
            </md-button>   
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button :disabled="!this.hasFlashLight" class="md-fab md-primary" @click.prevent="flashLightOnOff">
              <md-tooltip>Turn flash light on off</md-tooltip>
              <md-icon>flash_on</md-icon>
            </md-button>   
          </div> 
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button :disabled="!isPhotoTaken" class="md-fab md-primary" @click.prevent="saveImage">
              <md-tooltip>save photo</md-tooltip>
              <md-icon>file_upload</md-icon>
            </md-button>   
          </div>

          <video v-show="!isPhotoTaken && !isScanImg" ref="camera" autoplay loop muted height="480" width="640" style="margin-top:-250px;"></video>
          <canvas v-show="isPhotoTaken && !isScanImg" id="photoTaken" ref="canvas" height="480" width="640" style="margin-top:-250px;"></canvas>
          <img v-if="isScanImg" id="testImg" height="480" width="640" style="margin-top: -250px;">

          <div v-if="hasZoom">
             <input type="range" id="zoom" name="zoom">
          </div>   
          
          
          
              <!-- end webcam component -->
          </div>
              </md-dialog-actions>
            </div>
          </div>
          </div> 

        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
@import "../../public/chrisForm.css";


.layoutPlant {
  /*width: 20%;*/
  line-height: 1.5;
  color: #555555;
  display: inline-block;
  font-family: Roboto Slab;
  /*margin: auto;*/
  font-size: 20px;
  border: 1px;
  margin-left: 5px;
  margin-right: 5px;
}


.adjust{
  padding-top: 0;
  margin-top: 0;
}

.headingPlant {
  padding-top: 10px;
  padding-left: 12px;
  margin-bottom: 0px;
  color: #555555;
  width: 92%;
  line-height: 3;
  font-size: 34px;
  font-family: Roboto Slab;
  margin-left: 35px;
}

.camera-shoot {
   margin-left: 650px;
   /*margin-top: -200px;*/
}

hr {
   width: 100%;
   height: 5px;
   border: 0 none;
   margin-right: auto;
   margin-left: auto;
   margin-top: 10px;
   margin-bottom: 10px;
   background-color:#555;
}

#pb {
   margin-left: auto;
   margin-right: auto;
   margin-top: 10px;
   margin-bottom: 10px;

}

.btngroup {
  margin-left: 300px;
  margin-top: 30px;
}

.main {
  width: 950px;
  margin-left: 30px;
}

.errMsg {
   position: absolute;
   padding: 5px 5px 5px 5px;
   width: 100;
   height: 50;
   /*border: 2px solid #29303b;*/
   margin-top:-30px;
   margin-left: 250px;
   color: red;
}


</style>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import DatePickerBackdate from "./DatePickerBackDate.vue";
import callingApiCenter from "./CallingApiCenter.vue";
import BolPhotoZoomForm from "./BolPhotoZoomForm.vue";
import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import AutocompleteSelect from "./AutoCompleteDebounceSelect.vue";





const getInitialdataForm = () => ({
  scanWt: null,
  grade: null,
  bales: null,
  newSeal: null,
  specGrade: null
});
        
const getInitItem = () => ({
  // grade: null,
  // bales: null,
  // newSeal: null,
});

const SUPPORT_MEDIA_DEVICES = 'mediaDevices' in navigator;

const savePhotoReq = () => ({
     parentSeqNo: null,
     //parentLoadKey: null,
     photoType: null,
     parentType: null,
     photoKey: null,
     refTimeStamp: null,
     image: {
       fileName: null,
       folder: null,
       imageBase64: null,
     },
});

const photoItem = () => ({
     seqNo: null,
     apptNo: null,
     inboundShipment: null,
});

const photoMetaLoading = [
    {
      display: "WT SCAN",
      key: "BWT",
      fileName: "-wtScan.jpg",
    },
    //{
    //  display: "BOL Capture",
    //  key: "BWT1",
    //  fileName: "-BolPic.jpg",
    //},
  ];


export default {
  components: {callingApiCenter, DatePickerBackdate, BolPhotoZoomForm, AutocompleteCcicLocationSelect,AutocompleteSelect},
  mixins: [validationMixin],
  props: {
    mode: String,
    action: Function,
  },
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    item: getInitItem(),
    savePhotoInfo: savePhotoReq(), 
    photoItem: photoItem(),   
    items: [],
    selected: null,
    load: null,
    selected: null,
    scanWgtTicket: false,
    isCameraOpen: false,
    isLoading: false,
    isPhotoMode: false,
    isMultiCam: false,
    hasFlashLight: false,
    isPhotoTaken: false,
    isScanImg: false,
    hasZoom: false,
    isShotPhoto: false,
    img: null,
    cameras: [],
    camera: null,
    current_cam: null,
    link: '#',
    camnum: null,
    selectedItem: [],
    photoType: null,
    photos: [],
    //urlToSave: null,
    getPhotoRequest: null,
    selectedItem: [],
    hasPhoto: true,
    getTicketInfo: true,
    hasError: false,
    showErr: false,
    orgwt: null,
    recWindow: null,
  }),


  watch: {

  },

  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getMasterDataAsSelectOptionByGroup",
      "getUserProfile",
    ]),
  },

  mounted() {

  },

  validations: {
    dataForm: {
      // grade: { required },
      // bales: { required },
      // newSeal: { required },
      // scanWt:{required},
    },
  },

  methods: {
    // async openDialog(existingUser) {
    openDialog(existingUser) {  
      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.hasError = true;
      this.showErr = true;
      this.item = existingUser;
      this.load = existingUser;
      this.selectedItem = existingUser;
      this.orgwt = this.item.scanWt;
      this.dataForm.scanWt = this.item.scanWt;
      this.dataForm.grade = existingUser.grade;
      this.dataForm.specGrade = existingUser.specGrade;
      this.getTicketInfo = true;
      this.photoItem.seqNo = this.selectedItem.seqNo;
      this.recWindow = existingUser.receivingWindows;
      console.log("load: " + JSON.stringify(this.load));
      //var url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/upload_images/OUTBOUND/"
      var url = this.getPicURL();
      url = url + this.selectedItem.seqNo + "/-wtScan.jpg";
      this.urlExists(url);



      this.showDialog = true;
    },

      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

  //  handleGradeChanged(id) {
  //       this.item.grade = id;
  //   },

    handleGradeChanged(id, name){
        console.log(`handleGradeChanged`, id, name);
        this.dataForm.grade = id;
    },

    cancalAction() {
      this.$store.commit("clearApiError");
      this.cancelAction();
      //this.showDialog = false;
    },

    closeAction() {
      this.item.scanWt = this.orgwt;
      this.showDialog = false;
    },

    doCancelAction() {
      this.cancelAction();
      this.item.scanWt = this.orgwt;
      this.dataForm.scanWt = this.item.scanWt;
    },

    cancelAction() {
      this.scanWgtTicket = false;
      this.getTicketInfo = true;
      this.isCameraOpen = false;
      this.isPhotoTaken = false;
      this.isShotPhoto = false;
      this.item.scanWt = this.dataForm.scanWt;
      //this.dataForm.scanWt = "";
      this.stopCameraStream(); 

    },


    async scanAction(){
       this.getTicketInfo = false;
       this.scanWgtTicket = true;
       await this.detectCam();
    },

    async loadWT(scanWt)
    {
       console.log("outboundupload wt: " + scanWt);
       this.item.scanWt = scanWt;
    },

    async doSaveUser() {

      if (this.item.bales == null || this.item.bales == ""
      || this.item.newSeal == null || this.item.newSeal == ""
      || this.item.grade == null || this.item.grade == ""){
        window.confirm('Bales, Seal number and Grade are required!')
            return;
      };


      // if ( !Number.isInteger(Number(this.item.bales)) || this.item.bales.includes('.')  || this.item.bales < '1' ){
      //   window.confirm('Bales count must be a number!')
      //       return;
      // };

      if (Number.isInteger(Number(this.item.bales)) == false || Number(this.item.bales) < 1)
      {
          window.confirm("Bales count must be a positive whole number!");
          return;
      }
      this.item.bales = this.item.bales.trim();
      var p_bales = Number(this.item.bales);
      if (p_bales < 1 || p_bales > 99)
      {
          window.confirm("Bales count must be between 1 and 99!");
          return;

      }
      // if (Number(this.item.bales) >= 100)
      // {
      //     window.confirm("Bales count must be in or less than 2 digits number!");
      //     return;
      // }


      this.$v.dataForm.$touch();
      console.log(JSON.stringify(this.dataForm));

      if (this.$v.dataForm.$invalid) {
        //  this.$refs.top.$el.focus();
        return;
      }
      

      if (this.mode == "UPL") {
        this.load.scanWt = this.item.scanWt;
        this.load.grade = this.item.grade;
        this.load.bales = this.item.bales;
        this.load.newSeal = this.item.newSeal.toUpperCase();
        const seqNo = this.load.seqNo
        //api
        //  .post("/api/w/fsi/WebSaveOutbound", {
        newAPIPost("/api/w/fsi/WebSaveOutbound", {
            mode: "UPL",
            user: this.load.user,
            username: this.getUserProfile.username,
            seqNo: seqNo,
            scanWt: this.item.scanWt,
            grade: this.item.grade,
            specGrade: this.getContentFromBrace(this.item.specGrade),
            bales: this.item.bales,
            newSeal: this.item.newSeal.toUpperCase(),
          })
          .then((ticket) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(seqNo, ticket, this.mode);
          });
      }
    },

    toggleCamera() {
      if (this.isCameraOpen) {
          this.isCameraOpen = false;
          this.isPhotoTaken = false;
          this.isShotPhoto = false;
          this.isPhotoMode = true;
          this.isScanImg = false;
          this.isSaveScan = false;
          this.isCancelScan = false;
          this.stopCameraStream(); 
      } else {
          this.isCameraOpen = true;
          this.isPhotoMode = false;
          this.isScanImg = false;
          this.isSaveScan = false;
          this.isCancelScan = false;
          console.log("toggleCam::cameras length: " + this.cameras.length);
          this.camera = this.cameras[this.cameras.length -1];
          console.log("toggleCamera::camera deviceId: " + this.camera.deviceId);
          const devId = this.camera.deviceId;
          this.current_cam = devId;
          this.createCameraElement(devId);
      }
    },

    detectCam() {
      console.log("detect cam"); 
      if (SUPPORT_MEDIA_DEVICES) {
          this.mdevices = navigator.mediaDevices.enumerateDevices().then(devices => {
             this.cameras = devices.filter((device) => device.kind === 'videoinput');
             if (this.cameras.length === 0) {
                throw 'No camera found on this device';
             }
             console.log("cameras length: " + this.cameras.length);
             console.log("deviceId: " + this.cameras[0].deviceId);
             if (this.cameras.length === 1) {this.isMultiCam = false; console.log("device has 1 Cam")}
             else {this.isMultiCam = true; console.log("device has multi Cam")}
 
             this.cameras.forEach(
               (it) => {
                  console.log("device id: " + it.deviceId);
               }
             )
             this.toggleCamera();
          })
      }
    },

    refreshCamera() {
      this.setError("");
      this.isPhotoTaken = false;
      this.dataForm.scanWt = "";
      this.isPhotoMode = false;
      this.isScanImg = false;
      this.isSaveScan = false;
      this.pauseScan = false;
    },

    createCameraElement(camId) {
      this.isloading = true;
        
      if (SUPPORT_MEDIA_DEVICES) {

         navigator.mediaDevices.getUserMedia({
         video: {
           deviceId: camId,
           facingMode: ['user', 'enviornment'],
           width: { ideal: 1280 },
           height: { ideal: 1024 }
         }
         }).then(stream => {
            this.isLoading = false;
            this.$refs.camera.srcObject = stream;
            console.log("start stream");
            console.log(navigator.mediaDevices.getSupportedConstraints());
            const track = stream.getVideoTracks()[0];
            const capabilities = track.getCapabilities();
            console.log(track.getCapabilities());
            const settings = track.getSettings();
            console.log(track.getSettings());
            console.log("setting: " + settings.facingMode);
            console.log("setting: " + settings.zoom);
            if ('zoom' in settings)
            {
               this.hasZoom = true;
               console.log("zoom start");
               console.log("zoom min: " + capabilities.zoom.min);
               input.min = capabilities.zoom.min;
               console.log("zoom min: " + capabilities.zoom.max);
               input.max = capabilities.zoom.max;
               console.log("zoom min: " + capabilities.zoom.step);
               input.step = capabilities.zoom.step;
               input.value = settings.zoom;
               input.oninput = function(event) {
                 track.applyConstraints({advanced: [ {zoom: event.target.value} ]});
               }
            }
            else
            {
              this.hasZoom = false;
            }
          }
          ) 
      }

    },

    stopCameraStream() {
      if (this.$refs.camera && this.$refs.camera.srcObject)
      {
         let tracks = this.$refs.camera.srcObject.getTracks();
         console.log("number of tracks: " + tracks.length);
         tracks.forEach(
         track => {
           track.stop();
           console.log("track stopped");
         }
         )
      }
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
          this.isShotPhoto = true;
          const FLASH_TIMEOUT = 50;
          setTimeout( () => {
            this.isShotPhoto = false;
          }, FLASH_TIMEOUT);
      }
      this.isPhotoTaken = !this.isPhotoTaken;
      this.pauseScan = true;
      console.log("after take photo isPhotoTaken: " + this.isPhotoTaken);
      const context = this.$refs.canvas.getContext('2d');
      //context.drawImage(this.$refs.camera, 0, 0, 1280, 1024);
      //context.drawImage(this.$refs.camera, 0, 0, 480, 640);
      context.drawImage(this.$refs.camera, 0.5, 0.5, 640, 480);
      //context.drawImage(this.$refs.camera, 0, 0, 445, 600);
      //context.drawImage(this.$refs.camera, 0, 0);
      context.font = "24px Comic Sans MS";
      context.fillStyle = "white";
      context.textAlign = "center";
      var current = new Date();
      console.log("current date: " + current);
      var photo_refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();

      context.fillText(photo_refTimeStamp, this.$refs.canvas.width - 100, this.$refs.canvas.height - 30);
      console.log("host: " + location.host);
      this.isPhotoMode = true;

      //start text detection
      if (document.getElementById("pb"))
      {
        document.getElementById("pb").style.display = "";
      }
      if (document.getElementById("pb1"))
      {
        document.getElementById("pb1").style.display = "none";
      }
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");
      console.log("img: " + canvas);  
      var img = canvas.replace("data:image/octet-stream;base64,","");
      console.log("base64 img: " + img);  
      //const bol = api.post('/api/w/photo/WTDetection', {imageBase64: img, recWindow: this.recWindow})
      const bol = newAPIPost('/api/w/photo/WTDetection', {imageBase64: img, recWindow: this.recWindow})
            .then((it) => {
         this.$store.commit('clearApiError');
         console.log("internal var it length: " + it.length);
         console.log("internal var it: " + it);
         if (it.length > 15)
         {
            this.dataForm.scanWt = it.toString().substr(1,15)
         }
         else 
         {
            this.dataForm.scanWt = it;
         }
         console.log("selectedItem length: " + this.selectedItem.length);
         if (document.getElementById("pb"))
         {
            document.getElementById("pb").style.display = "none";
         }
         if (document.getElementById("pb1"))
         {
            document.getElementById("pb1").style.display = "";
         }
         //const wtprefix = /^LT/g;
         //console.log("wt number: " + this.dataForm.scanWt.match(wtprefix));
         //const found = this.dataForm.scanWt.match(wtprefix);
         if (this.dataForm.scanWt != null && this.dataForm.scanWt != "")
         {
            console.log("wt number prefix: " + this.dataForm.scanWt.substr(0,2))
            if (this.dataForm.scanWt.substr(0,2) != "LT")
            {
              if (this.dataForm.scanWt.substr(0,2) != "WT")
              {
                  this.setError("Please check the scaned Weight number. It is not in the right format!");
              }    
            }
         }
         else 
         {
            this.setError("Please check the scaned Weight number. It is not in the right format!");
         }
      })
    },

    switchCam() {
       this.stopCameraStream();
       console.log("before current cam id: " + this.current_cam);
       console.log("switchCam::cameras length: " + this.cameras.length);
       for (var i = 0; i < this.cameras.length; ++i)
       {
          console.log("device Id: " + this.cameras[i].deviceId);
          if (this.current_cam != this.cameras[i].deviceId) {
              this.current_cam = this.cameras[i].deviceId;
              break;
          }
       }
            
       console.log("after current cam id: " + this.current_cam);
       this.createCameraElement(this.current_cam);

    },

    flashLightOnOff() {

    },

    saveImage: function() {
                //console.log("downloadImage: selectedItem length: " + this.selectedItem.length);
                if (this.selectedItem != null) {
                   if (document.getElementById("pb"))
                   {
                       document.getElementById("pb").style.display = "";
                   }
                   if (document.getElementById("pb1"))
                   {
                       document.getElementById("pb1").style.display = "none";
                   }


                   console.log("selectItem inboundShipment: " + this.selectedItem.seqNo);
                   console.log("Outbound pareentSeqNo: " + this.selectedItem.seqNo);
                   //console.log("selectedItem parentSeqNo: " + this.selectedItem.apptNo);
                   //process to upload image
                   this.savePhotoInfo.parentSeqNo = this.selectedItem.seqNo;
                   this.savePhotoInfo.photoType = "BWT";
                   this.savePhotoInfo.parentType = "BWT";
                   this.savePhotoInfo.photoKey = "BWT";
                   var current = new Date();
                   console.log("current date: " + current);
                   this.savePhotoInfo.refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();
                   console.log("current date: " + this.savePhotoInfo.refTimeStamp);
                   this.savePhotoInfo.image.folder = `OUTBOUND/${this.savePhotoInfo.parentSeqNo}`;
                   this.savePhotoInfo.image.fileName = "-wtScan.jpg";
                   const regex = /image[/](jpeg|png|gif)/i;
                   var canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                       .replace(regex, "image/octet-stream");
                   if (this.isScanImg)
                   {
                      console.log("get testImg");
                      canvas = document.getElementById("testImg").src
                        .replace(regex, "image/octet-stream");
                   }     
                   console.log("img: " + canvas);  
                   var img = canvas.replace("data:image/octet-stream;base64,","");
                   console.log("base64 img: " + img);  

                   this.savePhotoInfo.image.imageBase64 = img;

                  
                   console.log("image folder: " + this.savePhotoInfo.image.folder);
                   console.log("Saving photo...");
                   //api.post('/api/w/ccic/photo/save', this.savePhotoInfo)
                   newAPIPost('/api/w/ccic/photo/save', this.savePhotoInfo)
                     .then( (it) => {
                      console.log("done with image saving");
                      console.log("set getPhotoRequest");
                      //this.onScan(this.dataForm.scanWt, true, this.selectedItem[0].inboundShipment);
                      if (document.getElementById("pb"))
                      {
                         document.getElementById("pb").style.display = "none";
                      }
                      if (document.getElementById("pb1"))
                      {
                         document.getElementById("pb1").style.display = "";
                      }

                      //this.cancelAction();
                      this.hasPhoto = true;
                      this.hasError = false;
                      this.cancalAction();
                   }
                   ) 

               }

    },
/*
    cancelAction() {
       this.isCameraOpen = false;
       this.isPhotoTaken = false;
       this.isShotPhoto = false;
       this.dataForm.scanWt = "";
       this.stopCameraStream(); 
    },
*/
    toggleItemPhoto() {
        console.log("scanWt in dataform: " + this.item.scanWt);
        this.$refs.BolPhotoZoomForm.openDialog(
        //this.$refs.BolPhotoForm.openDialog(
          `Photo.zip`,
          this.photoItem.seqNo,
          "BWT",
          photoMetaLoading,
          { seqNo: this.photoItem.seqNo,sortKey : 'BWT' },
          false,
          this.item.scanWt
        );
    },

    updatePhoto(url, seq){
      // const item = _(this.items)
      //     .find(it => it.apptNo === seq);
      //item.bolScan = url;
      console.log("url: " + url);
    },

    urlExists(url) {
      console.log("wt url: " + url);
      fetch(url)
      .then( (response) => {
        if (response.statusText === "OK")
        {
           console.log("url existed");
           this.hasPhoto = true;
           return true;
        }
        else
        {
           console.log("url not found");
           this.hasPhoto = false;
           return false;
        }

      }
      )
    },

    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },

    setError(msg)
    {
        if (document.getElementById("err"))
        {
           document.getElementById("err").textContent = msg;
        }
    },

    getPicURL()
    {
        var appURL = location.href.toUpperCase();
        console.log("appURL: " + appURL);
        var env = "dev";
        var picURL = "https://named-account-web-";
        if (appURL != null && appURL != "")
        {
           if (appURL.indexOf("DEV") > 0)
              env = "dev";
           if (appURL.indexOf("QAS") > 0)
              env = "qas";
           if (appURL.indexOf("PRD") > 0)
              env = "prd";
           if (appURL.indexOf("LOCALHOST") > 0)
              env = "dev";
        }
        else
          env = "";
        //picURL.concat(env, ".s3.us-west-2.amazonaws.com/upload_images/OUTBOUND/");
        picURL += env;
        picURL += ".s3.us-west-2.amazonaws.com/upload_images/OUTBOUND/";
        console.log("get wt pic url outbound: " + picURL);
        return picURL;
    },


  },
};
</script>
